import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';

const EvaluacionTercerosLayout = Loadable(lazy(() => import('features/EvaluacionTerceros/layout/EvaluacionTercerosLayout')));

const Bienvenida = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/Bienvenida')));
const Formulario = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/Formulario')));
const RevisionFinal = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/RevisionFinal')));
const ConfirmacionEnvio = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/ConfirmacionEnvio')));
const EnRevision = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/EnRevision')));
const CorreccionRequerida = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/CorreccionRequerida')));
const EnResolucion = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/EnResolucion')));
const ResultadoAprobado = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/ResultadoAprobado')));
const ResultadoRechazado = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/ResultadoRechazado')));
const LinkExpirado = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/LinkExpirado')));
const ErrorInesperado = Loadable(lazy(() => import('features/EvaluacionTerceros/pages/ErrorInesperado')));

const EvaluacionTercerosRoutes = {
  path: '/',
  children: [
    {
      path: 'evaluacion',
      element: <EvaluacionTercerosLayout />,
      // Sin errorElement, un fallo de render en el flujo del tercero cae en el
      // ErrorBoundary de fábrica de React Router, que muestra texto técnico en inglés.
      errorElement: <ErrorInesperado />,
      children: [
        {
          path: 'tercero',
          children: [
            {
              path: '',
              element: <Bienvenida />
            },
            {
              path: 'formulario',
              element: <Formulario />
            },
            {
              path: 'revision',
              element: <RevisionFinal />
            },
            {
              path: 'confirmacion-envio',
              element: <ConfirmacionEnvio />
            },
            {
              path: 'en-revision',
              element: <EnRevision />
            },
            {
              path: 'correccion-requerida',
              element: <CorreccionRequerida />
            },
            {
              path: 'en-resolucion',
              element: <EnResolucion />
            },
            {
              path: 'resultado-aprobado',
              element: <ResultadoAprobado />
            },
            {
              path: 'resultado-rechazado',
              element: <ResultadoRechazado />
            },
            {
              path: 'link-expirado',
              element: <LinkExpirado />
            }
          ]
        }
      ]
    },
    { path: '*', element: <Navigate to="/evaluacion/tercero" replace /> }
  ]
};

export default EvaluacionTercerosRoutes;
